"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePartySnapshotDto = exports.InvoicePartyInputDto = exports.INVOICE_PARTY_SOURCES = void 0;
const class_validator_1 = require("class-validator");
exports.INVOICE_PARTY_SOURCES = ["admefy", "registered", "external"];
class InvoicePartyInputDto {
    source;
    registeredUserId;
    name;
    address1;
    address2;
    country;
    email;
    phone;
    vatCode;
    registrationNumber;
}
exports.InvoicePartyInputDto = InvoicePartyInputDto;
__decorate([
    (0, class_validator_1.IsEnum)(exports.INVOICE_PARTY_SOURCES),
    __metadata("design:type", String)
], InvoicePartyInputDto.prototype, "source", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((party) => party.source === "registered"),
    __metadata("design:type", String)
], InvoicePartyInputDto.prototype, "registeredUserId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((party) => party.source === "external"),
    __metadata("design:type", String)
], InvoicePartyInputDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((party) => party.source === "external"),
    __metadata("design:type", String)
], InvoicePartyInputDto.prototype, "address1", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InvoicePartyInputDto.prototype, "address2", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((party) => party.source === "external"),
    __metadata("design:type", String)
], InvoicePartyInputDto.prototype, "country", void 0);
__decorate([
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.ValidateIf)((party) => party.source === "external"),
    __metadata("design:type", String)
], InvoicePartyInputDto.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InvoicePartyInputDto.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InvoicePartyInputDto.prototype, "vatCode", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InvoicePartyInputDto.prototype, "registrationNumber", void 0);
class InvoicePartySnapshotDto {
    source;
    registeredUserId;
    name;
    address1;
    address2;
    country;
    email;
    phone;
    vatCode;
    registrationNumber;
}
exports.InvoicePartySnapshotDto = InvoicePartySnapshotDto;
